import * as React from 'react';
import { Link } from 'react-router-dom';

function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    event.preventDefault();
}

export default function BasicBreadcrumbs() {

   
 
    return null

    return (
      
            <ul className="breadcrumb">                     
                   <li >
                   <Link
                    style={{ textDecoration: 'none' }}
                    to={"#"}
                    color="white"                 
                    className="breadcrumb__title">titre </Link>
               </li>             
            </ul>
   
    );
}
